import cetusIcon from '@assets/images/vault/cetus.svg';
// import bluefinIcon from '@assets/images/vault/bluefin.svg';

export const protocolList = [
  {
    label: 'all',
    name: 'All',
    icon: '',
  },
  {
    label: 'cetus',
    name: 'Cetus',
    icon: cetusIcon,
  },
  // {
  //   label: 'bluefin',
  //   name: 'Bluefin',
  //   icon: bluefinIcon,
  // },
] as const;

export type ProtocolListType = (typeof protocolList)[number]['label'];
